function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailNonVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B9B9B9"
    },
    points: "455.736,45.011 399.473,60.432 399.473,395.305 455.736,410.725 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCDCDC"
    },
    d: "M227.868,149.099L0.001,45.012C0,45.081,0,410.725,0,410.725l227.868-104.088l194.11,88.667V60.432 L227.868,149.099z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B9B9B9"
    },
    points: "227.868,191.297 0,410.725 455.736,410.725 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEEEEE"
    },
    points: "0,45.011 227.868,264.44 455.736,45.011 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5F1A"
    },
    d: "M399.473,241.934v225.055c62.149,0,112.527-50.379,112.527-112.527S461.621,241.934,399.473,241.934z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE834D"
    },
    d: "M399.473,241.934c43.503,0,78.769,50.379,78.769,112.527s-35.266,112.527-78.769,112.527 c-62.149,0-112.527-50.379-112.527-112.527S337.324,241.934,399.473,241.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M451.192,382.311l-27.849-27.849l27.849-27.849c6.592-6.592,6.592-17.279,0-23.87 c-6.592-6.592-17.279-6.592-23.87,0l-27.849,27.849l-27.849-27.849c-6.592-6.592-17.279-6.592-23.87,0s-6.592,17.279,0,23.87 l27.849,27.849l-27.849,27.849c-6.592,6.592-6.592,17.279,0,23.87c6.592,6.592,17.279,6.592,23.87,0l27.849-27.849l27.849,27.849 c6.592,6.592,17.279,6.592,23.87,0C457.784,399.59,457.784,388.903,451.192,382.311z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNonVerified);
export default __webpack_public_path__ + "static/media/mail-non-verified.bd8f3fd701bd6a0e699dffc3ecf080ce.svg";
export { ForwardRef as ReactComponent };